import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { getBreachOriginList as getBreachOriginListApi } from '../../helpers/breach_origin/api_helper';

export const getBreachOriginList = createAsyncThunk(
	'breachOrigin/getBreachOriginList',
	async params => {
		try {
			const response = await getBreachOriginListApi(params);
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener orígenes de incumplimiento.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);
